const state =  {
    isLoading : false,
    alertMessage : '',
    showAlert : false,
    userName : '',
    token : null,
}

const getters = {
    userName() {
        return state.userName;
    },
    token() {
        return state.token;
    },
    showAlert() {
        return state.showAlert;
    },
    alertMessage() {
        return state.alertMessage;
    },
    isLoading() {
        return state.isLoading;
    }
}
const mutations = {
    SET_USERNAME(state, payload) {
        state.userName = payload;
    },    
    SET_TOKEN(state, payload) {
        state.token = payload;
    },    
    SET_ISLOADING(state, payload) {
        state.isLoading = payload;
    },
    SET_ALERTMESSAGE(state, payload) {
        state.alertMessage = payload;
    },
    SET_SHOWALERT(state, payload) {
        state.showAlert = payload;
    },
}
const actions = {
    isLoading(context, value) {
        context.commit('SET_ISLOADING', value)
    },
    showAlert(context, value) {
        if(!value) {
            context.commit('SET_ALERTMESSAGE', '')
        }
        context.commit('SET_SHOWALERT', value)
    },
    alertMessage(context, value) {
        if(value === undefined || value === null || value === '') {
            context.commit('SET_SHOWALERT', false)
            context.commit('SET_ALERTMESSAGE', '')
        } else {
            context.commit('SET_SHOWALERT', true)
            context.commit('SET_ALERTMESSAGE', value)
        }
    },
}

export default{
    state, getters, mutations, actions
} 
